import template from './auction-top-popup.jade';

import { plural } from '@cian/utils';

const timeNow = (dateString) => {
  var d = new Date(dateString),
    h = (d.getHours()<10?'0':'') + d.getHours(),
    m = (d.getMinutes()<10?'0':'') + d.getMinutes();
  return h + ':' + m;
};

const SERVICE_IDS_MAP = {
  'paid': 'paid',
  'premium': 'premium',
  'premium+highlight': 'premium',
  'top3': 'top3',
};

const SERVICE_NAMES_MAP = {
  'paid': 'Платные',
  'premium': 'Премиум',
  'top3': 'ТОП',
};

export default [function() {
  return {
    template,
    scope: {
      data: '@',
      selectedOption: '='
    },
    controller: [
      '$scope',
      function($scope) {
        const data = JSON.parse($scope.data);

        const {
          actualDataDate,
          announcementCategory,
          topAnnouncementsBets,
          currentAnnouncementBet,
          serpUrl,
          serpUrlTitle,
          /** Количество объявлений над текущим среди всех VAS */
          betFullConcurrency,
          /** Количество объявлений над текущим среди текущего VAS */
          betServiceConcurrency
        } = data;

        const generateLimitTextForCompanies = (bet) => {
          if (bet && bet.companies && bet.companies.length > 3) {
            bet.limitText = `ещё ${bet.companies.length - 3}`;
            bet.companies = bet.companies.slice(0, 3);
          }
        };

        const handleStakeLimits = (bets) => {
          bets.forEach((bet) => generateLimitTextForCompanies(bet));
        };

        $scope.auctionUpdateDate = `Данные на ${timeNow(actualDataDate)}`;
        $scope.topAnnouncementsBets = topAnnouncementsBets;
        $scope.currentAnnouncementBet = currentAnnouncementBet;
        $scope.section = announcementCategory;
        $scope.serpUrl = serpUrl;
        $scope.serpUrlTitle = serpUrlTitle;

        /** Вычисляет фича-тогл проекта Сквозная конкуренция */
        $scope.isPenetratingConcurrencyEnabled = () => {
          return Number.isFinite(betFullConcurrency) && Number.isFinite(betServiceConcurrency);
        }

        /** Возвращает текст в формате Ставки лидеров, чьи [VAS] объявления показываются на первых позициях */
        $scope.getConcurrencyByServiceText = () => {
          const selectedOption = $scope.selectedOption;

          const pluralServiceName = SERVICE_NAMES_MAP[SERVICE_IDS_MAP[selectedOption]];

          return `Ставки лидеров, чьи ${pluralServiceName} объявления показываются на первых позициях `;
        };

        handleStakeLimits($scope.topAnnouncementsBets);
        generateLimitTextForCompanies($scope.currentAnnouncementBet);

        $scope.getCurrentPositionCSSClass = (stakePosition) => {
          if (currentAnnouncementBet && stakePosition.auctionPlace === currentAnnouncementBet.auctionPlace) {
            return 'auction-popup__position-value__current';
          }

          return '';
        };

        $scope.getCompanyIcon = (company) => {
          if (company.avatarUrl) {
            return `<img src="${company.avatarUrl}" title="${company.name}"></img>`;
          }

          return `<span title="${company.name}">A</span>`;
        };
      }
    ],
    controllerAs: 'auctionPopupCtrl'
  }
}];
